<template>
 
  <v-content>
    <!-- <v-layout>
      <button
        style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
        @click="pay()"
        role="link"
      >
        Checkout
      </button>
      <div id="error-message"></div>
    </v-layout> -->
    <!-- <span>{{sessionId}} </span> -->
  </v-content>
</template>

<script>


var stripe = Stripe('pk_test_6EshQ31WqmoOtVC1dXMGolCx00uifcvy67');

import store from "@/store"
import { mapState } from 'vuex'

export default {
  created: function () {
    this.initCheckout()

  },
  data: () => ({
    
  }),
  methods: {
    initCheckout: function () {

      this.$store.dispatch("payments/stripeSessionA")
      .then((res) => {
        console.log(res)
        console.log(res.id)
        stripe.redirectToCheckout({
          sessionId: 'cs_test_bMTShi8GSDlg9lBv1JlelLRewWAv68nEUsyN7UbjbE3LlOrFURE663Kr' // res.id
        }).then(function (result) {
          console.log(result)
        });
      }) 

      
      
    }
  },

  computed: {
        ...mapState({
          sessionId: state => state.payments.sessionId,
          
        }),
      },
}
</script>